// extracted by mini-css-extract-plugin
export var burgerHolder = "Nav-module--burgerHolder--f5bbb";
export var navHolder = "Nav-module--navHolder--dbf66";